import { render, staticRenderFns } from "./FactorStates.vue?vue&type=template&id=50b91f85&scoped=true"
import script from "./FactorStates.vue?vue&type=script&lang=ts"
export * from "./FactorStates.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b91f85",
  null
  
)

export default component.exports